var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('SemcogHeader',[_c('span',{staticClass:"title",staticStyle:{"line-height":"2em","font-size":"1em"}},[_vm._v(" Building Footprints ")])]),_c('mainmap')],1)}
var staticRenderFns = []

export { render, staticRenderFns }